import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { TextButton } from '../../shared/text-button/text-button';
import { Alert } from '../../shared/alert/alert';
export const T2CPendingAlert = ({ openResendInviteModal, }) => {
    return (React.createElement(Alert, { status: "info" },
        React.createElement(Typography, { variant: "body-base" }, "Text2Confirm Invite Pending Acceptance"),
        React.createElement(TextButton, { className: "sui-mt-4", onClick: openResendInviteModal }, "Resend Invite")));
};
